import React from "react";
import { useTranslation } from "react-i18next";
import { convertLanguageToField } from "../../../utils/functions";
import styles from "./vodcategorycard.module.css";

export default function VODCateogryCard({ category, index, onClick }) {
  const { i18n } = useTranslation();
  const title = convertLanguageToField(i18n.language, "title");
  const description = convertLanguageToField(i18n.language, "description");
  let image;
  let card = "";

  switch (category.id_categoria) {
    case 2:
      image = require("../../../assets/images/games/truthOrDareCategories/fogo.png");
      card = styles["category-2"];
      break;
    case 3:
      image = require("../../../assets/images/games/truthOrDareCategories/boca.png");
      card = styles["category-3"];
      break;
    case 4:
      image = require("../../../assets/images/games/truthOrDareCategories/chicote.png");
      card = styles["category-4"];
      break;
    default:
      image = require("../../../assets/images/games/truthOrDareCategories/nuvem.png");
      card = styles["category-1"];
      break;
  }

  const handleClick = () => {
    if (onClick) {
      onClick(index);
    }
  };

  return (
    <div
      className="zoom-in"
      style={{
        "--animation-delay": `${index * 0.1}s`,
        "--animation-duration": ".5s",
      }}
    >
      <button
        className={`${card} ${styles.card} touchable-opacity`}
        onClick={handleClick}
      >
        <div className="relative w-full h-full">
          <div className="absolute top-[-1rem] right-[-20px]">
            <img
              className="h-[90px] w-[120px] object-contain object-right-top"
              src={image}
              alt=""
            />
          </div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="flex flex-col ">
            <h2 className="text-left text-2xl font-bold">{category[title]}</h2>
            <span className="text-left text-xs">{category[description]}</span>
          </div>
          <div className="w-48"></div>
        </div>
      </button>
    </div>
  );
}
